import request from "@/utils/request";
const qs = require("qs");
import { MLMReport } from "@/utils/requestApi";

// progresss

export function listSending(data) {
  return request({
    url: MLMReport() + "/purchase_order/list_sending",
    method: "POST",
    data: qs.stringify(data)
  });
}



// WEBPACK FOOTER //
// ./src/api/listSending.js